import React from "react";
import { useIntl } from "react-intl";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function DensitySelect({
  selectedDensity,
  options,
  onChange,
  dataAttr,
  isDisabled,
}) {
  const intl = useIntl();

  const selectedOption = options.find(
    (option) => Number(option.value) === Number(selectedDensity?.value),
  );

  return (
    <div className="audience-search__field">
      <div className="idh-label">
        <IDHFormattedMessage id="front_density" defaultMessage="Density" />
      </div>
      <div className="audience-search__field-columns">
        <div className="audience-search__field-col-1">
          <CustomSelect
            placeholder={intl.formatMessage({
              id: "front_select_gender_density",
              defaultMessage: "Select",
            })}
            value={selectedOption}
            options={options}
            onChange={(option) => {
              if (option) {
                onChange({ value: option.value });
              } else {
                onChange(option);
              }
            }}
            isDisabled={isDisabled}
            dataAttr={dataAttr}
          />
        </div>
        <div className="audience-search__field-col-1" />
      </div>
    </div>
  );
}
